export default "__VITE_PUBLIC_ASSET__0347eb3d__"